import { render, staticRenderFns } from "./FilterItemCompare2.vue?vue&type=template&id=94b61b1a&"
import script from "./FilterItemCompare2.vue?vue&type=script&lang=js&"
export * from "./FilterItemCompare2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports